import { CollectionInformation } from "src/app/models/collectionInformation";

export class Folder {
    _id: string;
    name: string;
    selected?: boolean = false;
    parentId ?: string = '';
    relativePath: string;
    subFolders: Array<Folder>;
    assetList: Array<Folder>;
    displayImage: string;

    constructor(name) {
        this.name = name;
    }
}